import type { Topic } from "@/types";

export const topics: Topic[] = [
  {
    id: "tp-1",
    title: "2025-2026 赛季前瞻：群雄逐鹿，谁主沉浮",
    summary: "新赛季揭幕战打响，东西部格局重新洗牌，雷霆、凯尔特人、掘金三强争霸，多支年轻球队强势崛起。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20basketball%20arena%20court%20at%20night%20with%20dramatic%20spotlights%20and%20deep%20navy%20blue%20tones%20with%20orange%20glow%20accents%2C%20empty%20hardwood%20floor%2C%20cinematic%20sports%20atmosphere%2C%20moody%20background%20with%20strong%20contrast%2C%20professional%20editorial%20photography&width=800&height=560&seq=nba-topic-1&orientation=landscape",
    category: "赛季专题",
    date: "2026-10-12",
    link: "/category/2025-2026",
  },
  {
    id: "tp-2",
    title: "季后赛席位之争：西部群狼混战全纪录",
    summary: "西部前十球队胜场差极小，每一场比赛都可能改写排名，我们为你梳理季后赛席位争夺的关键战役。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20stylized%20basketball%20motion%20blur%20with%20deep%20navy%20blue%20gradient%20and%20vivid%20orange%20light%20streaks%2C%20energetic%20sports%20texture%2C%20clean%20background%20with%20negative%20space%2C%20cinematic%20lighting%2C%20editorial%20sports%20photography&width=800&height=560&seq=nba-topic-2&orientation=landscape",
    category: "赛事分析",
    date: "2026-10-11",
    link: "/category/2024-2025",
  },
  {
    id: "tp-3",
    title: "明星球员集锦：本赛季最值得回看的十佳球",
    summary: "从绝杀三分到暴力隔扣，盘点本赛季至今最令人血脉偾张的十个高光瞬间。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20silhouette%20of%20a%20basketball%20player%20dunking%20against%20a%20dark%20navy%20gradient%20background%20with%20orange%20lens%20flare%20and%20light%20streaks%2C%20high%20contrast%20cinematic%20sports%20poster%2C%20clean%20composition%2C%20ultra%20detailed&width=800&height=560&seq=nba-topic-3&orientation=landscape",
    category: "集锦",
    date: "2026-10-10",
    link: "/category/2025-2026",
  },
  {
    id: "tp-4",
    title: "数据实验室：三分效率如何重塑现代篮球",
    summary: "空间与效率成为胜负手，我们用数据解读三分球对比赛节奏与战术体系的深远影响。",
    image: "https://readdy.ai/api/search-image?query=Contemporary%20sports%20data%20visualization%20concept%20with%20glowing%20charts%20and%20basketball%20on%20a%20dark%20navy%20blue%20surface%2C%20orange%20accent%20highlights%2C%20clean%20minimal%20background%2C%20cinematic%20studio%20lighting%2C%20editorial%20photography&width=800&height=560&seq=nba-topic-4&orientation=landscape",
    category: "数据",
    date: "2026-10-09",
    link: "/teams",
  },
  {
    id: "tp-5",
    title: "全明星周末：票选与表演赛全流程指南",
    summary: "从票选规则到周末赛程安排，带你提前了解全明星周末的每一个精彩环节。",
    image: "https://readdy.ai/api/search-image?query=Festive%20stylized%20basketball%20all%20star%20celebration%20scene%20with%20confetti%20and%20spotlights%2C%20deep%20navy%20blue%20and%20warm%20orange%20palette%2C%20abstract%20clean%20background%20with%20negative%20space%2C%20cinematic%20sports%20poster&width=800&height=560&seq=nba-topic-5&orientation=landscape",
    category: "全明星",
    date: "2026-10-08",
    link: "/category/2024-2025",
  },
  {
    id: "tp-6",
    title: "幕后故事：一支冠军球队的战术演化史",
    summary: "从挡拆到无球跑动，深度解析顶级球队如何在漫长赛季中不断调整战术并最终登顶。",
    image: "https://readdy.ai/api/search-image?query=Tactical%20basketball%20coach%20whiteboard%20with%20play%20diagrams%20in%20a%20dark%20navy%20blue%20locker%20room%2C%20orange%20warm%20accent%20lighting%2C%20clean%20moody%20background%2C%20cinematic%20editorial%20photography&width=800&height=560&seq=nba-topic-6&orientation=landscape",
    category: "深度",
    date: "2026-10-07",
    link: "/about",
  },
];